<script lang="ts">
  import { Marquee } from '@squareup/public-web-design-system';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import type { PwNextImageMarqueeProps } from './types';

  const { entryId, customCssClass, spacing, slides }: PwNextImageMarqueeProps = $props();
</script>

<div
  class="PwNextImageMarquee PwNextImageMarquee-{entryId}-box-properties {customCssClass}"
  class:PwNextImageMarquee-no-spacing={!spacing}
  data-entry-id={entryId}
>
  <Marquee {slides}>
    {#snippet slide({ slide })}
      <DynamicChildrenComponent children={[slide]} />
    {/snippet}
  </Marquee>
</div>

<style lang="scss">
  :global {
    .PwNextImageMarquee .MediaControls {
      border-width: 0;
      cursor: pointer;

      // add fallbacks, so the button renders nicely in XMS-FE where PWDS custom props are not available
      width: var(--media-controls-width, 5rem);
      height: var(--media-controls-height, 5rem);
      background-color: var(--media-controls-background-color-default, rgba(149, 149, 149, 0.5));
    }

    .PwNextImageMarquee-no-spacing .Marquee__slide {
      padding-left: 0;
    }
  }
</style>
